<template>
  <div class="main-filter">
    <BasePreloader v-if="pending"/>

    <div v-if="dynamicFilters"
         class="main-filter__item">
      <div class="main-filter__item-inner">

        <FilterGroup :title="$tFilter('Popular filters')"
                     :open-default="isGroupOpen"
                     class="main-filter__group"
        >
          <MainFilterTopFilters/>
        </FilterGroup>
        <FilterGroup :title="$tFilter('Profession')"
                     :open-default="isGroupOpen"
                     class="main-filter__group"
        >
          <MainFilterProfessionAndCategories/>
        </FilterGroup>
        <FilterGroup :title="$tFilter('Location')"
                     :open-default="isGroupOpen"
                     class="main-filter__group"
        >
          <MainFilterLocations/>
        </FilterGroup>

        <!-- DYNAMIC PARAMS -->
        <MainFilterDynamicParams/>


        <MainFilterFixedPanel/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import FilterGroup from "./FilterGroup";
  import MainFilterTopFilters from "./MainFilterTopFilters";
  import MainFilterProfessionAndCategories from "./MainFilterProfessionAndCategories";
  import MainFilterLocations from "./MainFilterLocations";
  import MainFilterDynamicParams from "./MainFilterDynamicParams";
  import MainFilterFixedPanel from "./MainFilterFixedPanel";

  export default {
    name: "SideFilter",
    components: {
      FilterGroup,
      MainFilterTopFilters,
      // FilterLocation,
      MainFilterProfessionAndCategories,
      MainFilterLocations,
      MainFilterDynamicParams,
      MainFilterFixedPanel,
    },
    data() {
      return {
        isGroupOpen: true,
        salary: []
      }
    },
    computed: {
      ...mapState('vacancies', [
        'pending',
        'dynamicFilters',
        'dynamicRouteFilters',
      ]),
      currentCurrency() {
        return this.$store.state.currentCurrency
      },
    },
    methods: {
      onExperienceToInput(value) {
        value = parseFloat(value) || 0
        this.$set(this.experience, 0, value)
      },
      onGroupToggle() {
        this.isGroupOpen = !this.isGroupOpen
      },
      onDirectionLoaded() {
        this.loadCategories(this.selectedDirection && this.selectedDirection.id)
      },
      onDirectionInput(direction) {
        const newRoute = {
          query: {...this.$route.query}
        }

        if (direction) {
          newRoute.name = 'vacancies'

          newRoute.query.direction = direction.slug
        } else {
          newRoute.name = 'vacancies'
          delete newRoute.query.direction
        }

        if (this.$route.query['category_id']) {
          delete newRoute.query['category_id']
        }

        this.$router.push(newRoute)

        this.loadCategories(direction && direction.id)
      },
      loadCategories(directionId) {
        if (!directionId) {
          directionId = this.selectedDirection && this.selectedDirection.id
        }

        this.$store.dispatch('filter/loadCategories', directionId)
      },
      isCategoryChecked(category) {
        return this.professionsIds.includes(category.category.slug)
      },
      onCategoryInput(isAddCategory, category) {
        let newIds

        if (isAddCategory) {
          newIds = [...this.professionsIds, category.category.slug]
        } else {
          this.removeAllDynamicParamsByCategoryId(category.id)
          newIds = this.professionsIds.filter(id => id !== category.category.slug)
        }

        let routeName = 'vacancies'

        if (this.$route.params.filters && this.$route.params.dynamic) {
          routeName = 'vacancies-with-static&dynamic'
        } else if (this.$route.params.filters) {
          routeName = 'vacancies-with-static'
        } else if (this.$route.params.dynamic) {
          routeName = 'vacancies-with-dynamic'
        }

        let directionId = this.$route.query.direction

        this.$router.push({
          name: routeName,
          params: {
            ...this.$route.params,
            professionsIds: newIds
          },
          query: {
            ...this.$route.query,
            direction: directionId
          }
        }).catch(this.handleError)
      },

      removeAllDynamicParamsByCategoryId(id) {
        const category = this.categoriesList.find(c => c.id === id)
        if (!category) return
        let selectedParams = {...this.selectedDynamicParams}

        category.params.forEach(param => {
          if (selectedParams[param.slug]) {
            this.setDynamicParam(param.slug, [])
          }
        })
      },

      //STATIC PARAMS
      onStaticParamInput(value, queryName) {
        this.setFilter(queryName, value && value.id)
      },
      getCurrentStaticParams(list, queryName) {
        if (!list) return null
        let val = this.selectedFilters[queryName]
        if (!val) return null
        val = val.toString()

        return list.find(item => item.id.toString() === val)
      },
      addLinksToOptions(options = [], type, name) {
        return options.map(option => {
          option = {...option}

          const routeName = type === 'filter' ? 'vacancies-with-static' : 'vacancies-with-dynamic'
          const paramName = type === 'filter' ? 'static' : 'dynamic'

          if (option.index) {
            option.route = {
              name: routeName,
              params: {
                [paramName]: [name + '-' + (option.slug || option.id)]
              }
            }
          }

          return option
        })
      },
      isCheckedRadio(value, option) {
        return (value && (value.slug || value.id)) === (option && (option.slug || option.id))
      },
    },
    watch: {},
    created() {

    }
  }
</script>

<style>

</style>
